import React, { useEffect, useState } from "react";
import MainLayout from "./MainLayout";
import UserService from "../../Services/UserList";
import Swal from "sweetalert2";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Paper,
  Box,
  Button,
  IconButton,
  Stack,
  Autocomplete,
  Typography,
  Grid,
  InputAdornment,
  Checkbox,
  TableSortLabel,
  Chip,
  Avatar,
  Tooltip,
} from "@mui/material";
import Loader from "../utils/Loader";
import * as XLSX from "xlsx"; // Import XLSX library
import { saveAs } from "file-saver"; // Import file-saver for saving files
import PreviewIcon from "@mui/icons-material/Preview";
import DownloadIcon from "@mui/icons-material/Download";
import { useLocation, useNavigate } from "react-router-dom";
import DownloadSummary from "../users/DownloadSummary";
import { useSelector, useDispatch } from "react-redux";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import TableChartIcon from "@mui/icons-material/TableChart";
import MultipleStopIcon from "@mui/icons-material/MultipleStop";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import PDF from "../users/PDF";
import {
  fetchCommunicationImages,
  fetchCoverImages,
  fetchLastImages,
  fetchSummaryImages,
  fetchTechImages,
  fetchThemeImages,
} from "../../redux/slices/pdfSlice";
import {
  Block,
  BlockOutlined,
  CalendarMonth,
  ClearAll,
  Search,
} from "@mui/icons-material";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import SearchIcon from "@mui/icons-material/Search";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import BusinessIcon from "@mui/icons-material/Business";
import { fetchProject } from "../../redux/slices/projectSlice";
import MultiSelectWithCheckbox from "../utils/MultiSelectWithCheckbox";
import { TableBodySkeleton } from "../utils/TableSkeleton";
import ShareQuoteDialog from "../utils/ShareQuoteDialog";
import RoleSelect from "../utils/RoleSelect";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { usePdf } from "../context/pdfContext";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import ExtractAllButtonThree from "../utils/ExtractAllButtonThree";
import { ClickableTableLink } from "./ClickableTableLink";
import MonthFY from "../MonthFY";
import YearFY from "../YearFY";
import FilterBar2 from "./admin_dashboard/FilterBar2";
import AllQuotationsAnalysis from "../utils/AllQuotationsAnalysis";


const roleOpt = [
  { label: "IC", value: 2 },
  { label: "BSP", value: 3 },
  { label: "DSP", value: 4 },
  { label: "BD", value: 5 },
  { label: "Sales Enabler", value: 6 },
  { label: "Dealer", value: 7 },
  { label: "Studio", value: 8 },
];

const FY_YEAR_OPTIONS = [
  { label: "2026-2027", value: "2026" },
  { label: "2025-2026", value: "2025" },
  { label: "2024-2025", value: "2024" },
  { label: "2023-2024", value: "2023" },
];

const Projects = () => {
  const { state } = useLocation();
  const { projectData, status, count, clientOpt, userOpt, stats } = useSelector(
    (state) => state.projects
  );
  const { regionOpt, stateOpt } = useSelector((state) => state.adminOption);
  const [loading, setLoading] = useState(false);
  const [dumpLoad, setDumpLoad] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState(state && state?.search || "");
  const [excelLoading, setExcelLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [showComponent, setshowComponent] = useState(false);
  const [projectId, setprojectId] = useState();
  const [dataFromDownloadSummary, setDataFromDownloadSummary] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedUsers, setSelectedUsers] = useState(() => {
    if (state?.users && state.users?.length > 0 && userOpt && userOpt.length > 0) {
      return userOpt.filter((user) =>
        state.users?.some((code) => user.label.includes(code))
      );
    }
    return [];
  });

  const [selectedClients, setSelectedClients] = useState([]);
  const currentYears = new Date().getFullYear();
  const current_month = String(new Date().getMonth() + 1).padStart(2, "0");

  const [selectedRegion, setSelectedRegion] = useState(() => {
    if (state?.regions && state.regions.length > 0 && regionOpt) {
      return regionOpt.filter((reg, idx) =>
        state.regions.includes(idx) ||
        state.regions.includes(idx + 1) ||
        state.regions.some(val => String(val).toLowerCase() === String(reg.value).toLowerCase())
      );
    }
    return [];
  });

  const [selectedState, setSelectedState] = useState(() => {
    if (state?.states && state.states.length > 0 && stateOpt) {
      return stateOpt.filter((st, idx) =>
        state.states.includes(idx) ||
        state.states.includes(idx + 1) ||
        state.states.some(val => String(val).toLowerCase() === String(st.value).toLowerCase())
      );
    }
    return [];
  });


  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);

  const [selectedMonth, setSelectedMonth] = useState(() => {
    if (state && state.months) return state.months;

    const fullFYMonths = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];

    const currentCalendarMonth = new Date().getMonth() + 1;

    const currentMonthIndex = fullFYMonths.indexOf(currentCalendarMonth);

    return fullFYMonths.slice(0, currentMonthIndex + 1);
  });

  const [selectedYear, setSelectedYear] = useState(() => {
    if (state && state.years) {
      const yearsArray = Array.isArray(state.years) ? state.years.map(String) : [String(state.years)];
      return FY_YEAR_OPTIONS.filter((y) => yearsArray.includes(y.value));
    }
    const currentYrStr = String(new Date().getFullYear());
    return FY_YEAR_OPTIONS.filter((y) => y.value === currentYrStr);
  });

  const [roleId, setRoleId] = useState(() => {
    if (state && state.roles?.length > 0 && roleOpt) {
      return roleOpt.filter((r) => state.roles.includes(r.value) || state.roles.includes(r.label));
    }
    return [];
  });

  const [sortBy, setSortBy] = useState({
    sort_by: "",
    order: "desc",
  });
  const dispatch = useDispatch();
  const { downloadPdf } = usePdf();


  const counts = count || 0;
  const {
    coverImages,
    summaryImages,
    themeImages,
    lastImages,
    techImages,
    communicationImages,
    getStatus,
  } = useSelector((state) => state.pdfImages);

  const navigate = useNavigate();

  const handleDataFromDownloadSummary = (data) => {
    setDataFromDownloadSummary(data);
    setprojectId("");
  };

  const filterConfigs = [
    { id: "client", label: "Client", options: clientOpt || [], selected: selectedClients },
    { id: "role", label: "Role", options: roleOpt || [], selected: roleId },
    { id: "user", label: "User", options: userOpt || [], selected: selectedUsers },
    { id: "region", label: "Region", options: regionOpt || [], selected: selectedRegion },
    { id: "state", label: "State", options: stateOpt || [], selected: selectedState },
    { id: "year", label: "Year (FY)", options: FY_YEAR_OPTIONS, selected: selectedYear },
  ];

  const handleMonthChange = (newMonths) => {
    setSelectedMonth(newMonths);
    if (newMonths?.length > 0 && selectedYear?.length === 0) {
      const currentYrStr = String(new Date().getFullYear());
      setSelectedYear(FY_YEAR_OPTIONS.filter((y) => y.value === currentYrStr));
    }
  };

  const handleFilterChange = (filterId, nextSelected) => {
    switch (filterId) {
      case "client": setSelectedClients(nextSelected); break;
      case "role": setRoleId(nextSelected); break;
      case "user": setSelectedUsers(nextSelected); break;
      case "region": setSelectedRegion(nextSelected); break;
      case "state": setSelectedState(nextSelected); break;
      case "year":
        setSelectedYear(nextSelected);
        if (nextSelected.length === 0) {
          setSelectedMonth([]);
        } else if (selectedMonth?.length === 0) {
          const fullFYMonths = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
          const currentCalendarMonth = new Date().getMonth() + 1;
          const currentMonthIndex = fullFYMonths.indexOf(currentCalendarMonth);
          setSelectedMonth(fullFYMonths.slice(0, currentMonthIndex + 1));
        }
        break;
      default: break;
    }
  };

  useEffect(() => {
    if (
      dataFromDownloadSummary == "downloaded" ||
      dataFromDownloadSummary == "failed"
    ) {
      setExcelLoading(false);
    }
  }, [dataFromDownloadSummary]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDataFromDownloadSummary("");
      setprojectId("");
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [projectId, dataFromDownloadSummary]);

  useEffect(() => {
    if (state?.client && clientOpt && clientOpt.length > 0 && selectedClients.length === 0) {
      const client = clientOpt.find(c => String(c.value) === String(state.client) || String(c.label) === String(state.client));
      if (client) {
        setSelectedClients([client]);
      }
    }
  }, [state, clientOpt]);

  useEffect(() => {
    if (state?.users && state.users?.length > 0 && userOpt && userOpt.length > 0 && selectedUsers.length === 0) {
      const users = userOpt.filter((user) =>
        state.users.some((code) => user.label.includes(code))
      );
      if (users.length > 0) {
        setSelectedUsers(users);
      }
    }
  }, [state, userOpt]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isUsingDateRange = Boolean(selectedFromDate || selectedToDate || fromDate || toDate);
  const hasValidFilters = isUsingDateRange || Boolean(selectedYear?.length > 0 && selectedMonth?.length > 0);

  useEffect(() => {
    if (!hasValidFilters) {
      return;
    }
    dispatch(
      fetchProject({
        search: searchTerm,
        from: selectedFromDate,
        to: selectedToDate,
        month: selectedMonth,
        year: selectedYear?.map((y) => y.value),
        user: selectedUsers?.map((u) => u.value),
        client: selectedClients?.map((u) => u.value),
        state: selectedState?.map((u) => u.value),
        region: selectedRegion?.map((u) => u.value),
        page: page,
        rowsPerPage: rowsPerPage,
        sort_by: sortBy.sort_by,
        sort_order: sortBy.order,
        role: roleId?.map((u) => u.value),
      })
    );
  }, [
    searchTerm,
    selectedClients,
    selectedUsers,
    selectedMonth,
    selectedYear,
    page,
    rowsPerPage,
    selectedFromDate,
    selectedState,
    selectedRegion,
    selectedToDate,
    sortBy,
    roleId,
    hasValidFilters,
  ]);

  const handleDownloadExcel = () => {
    if (!hasValidFilters || !projectData || projectData.length === 0) {
      Swal.fire({
        title: "No Data Available",
        text: "There is no quotation data to export based on current filters.",
        icon: "info",
        confirmButtonColor: "#1565c0",
      });
      return;
    }

    setLoading(true);

    const getRoleName = (role, roleName) => {
      if (roleName) return roleName;
      const roleMap = {
        2: "IC",
        3: "BSP",
        4: "DSP",
        5: "BD",
        6: "Sales Enabler",
        7: "Dealer",
        8: "Studio",
      };
      return roleMap[role] || role || "N/A";
    };

    const getSharedWithText = (shared) => {
      if (!shared) return "Not Shared";
      return shared
        .split(",")
        .map((userId) => {
          const u = userOpt?.find((opt) => String(opt.value) === userId.trim());
          return u ? u.label : userId.trim();
        })
        .join(", ");
    };

    const data = projectData.map((item, index) => [
      page * rowsPerPage + index + 1,
      item.project_id || "N/A",
      item.offer_price !== null && item.offer_price !== undefined ? Number(item.offer_price) : 0,
      item.list_price !== null && item.list_price !== undefined ? Number(item.list_price) : 0,
      item.client_name || "N/A",
      item.client_region || "N/A",
      item.client_state || "N/A",
      item.username || "N/A",
      item.user_region || "N/A",
      item.user_state || "N/A",
      getRoleName(item.role, item.roleName),
      getSharedWithText(item.shared),
      item.transferred_user_name ? item.transferred_user_name : "Not Transferred",
      `${item.pdfCount || 0} | ${item.excelCount || 0} | ${item.whatsCount || 0}`,
      item.valid_date && item.valid_date !== "0000-00-00"
        ? new Date(item.valid_date).toLocaleDateString("en-GB")
        : "N/A",
      item.status || "N/A",
      item.created_at && item.created_at !== "0000-00-00 00:00:00"
        ? new Date(item.created_at).toLocaleDateString("en-GB")
        : "N/A",
      item.created_at && item.created_at !== "0000-00-00 00:00:00"
        ? new Date(item.created_at).toLocaleString("default", { month: "short" })
        : "N/A",
      item.created_at && item.created_at !== "0000-00-00 00:00:00"
        ? new Date(item.created_at).getFullYear()
        : "N/A",
      item.created_at && item.created_at !== "0000-00-00 00:00:00"
        ? new Date(item.created_at).toLocaleTimeString()
        : "N/A",
      item.updated_at && item.updated_at !== "0000-00-00 00:00:00"
        ? new Date(item.updated_at).toLocaleDateString("en-GB")
        : "N/A",
      item.updated_at && item.updated_at !== "0000-00-00 00:00:00"
        ? new Date(item.updated_at).toLocaleTimeString()
        : "N/A",
    ]);

    const sheetData = [
      [
        "SL No.",
        "Quotation ID",
        "Offer Price",
        "List Price",
        "Client",
        "Client's Region",
        "Client's State",
        "Username",
        "User's Region",
        "User's State",
        "Role",
        "Shared With",
        "Transferred From",
        "PDF | Excel | Whatsapp",
        "Valid Upto",
        "Stage",
        "Created At",
        "Month",
        "Year",
        "Time",
        "Updated At",
        "Update Time",
      ],
      ...data,
    ];

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    const wscols = [
      { wch: 8 },  // SL No.
      { wch: 22 }, // Quotation ID
      { wch: 15 }, // Offer Price
      { wch: 15 }, // List Price
      { wch: 25 }, // Client
      { wch: 20 }, // Client's Region
      { wch: 20 }, // Client's State
      { wch: 20 }, // Username
      { wch: 20 }, // User's Region
      { wch: 20 }, // User's State
      { wch: 15 }, // Role
      { wch: 25 }, // Shared With
      { wch: 20 }, // Transferred From
      { wch: 22 }, // PDF | Excel | Whatsapp
      { wch: 15 }, // Valid Upto
      { wch: 15 }, // Stage
      { wch: 15 }, // Created At
      { wch: 10 }, // Month
      { wch: 10 }, // Year
      { wch: 15 }, // Time
      { wch: 15 }, // Updated At
      { wch: 15 }, // Update Time
    ];
    ws["!cols"] = wscols;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Quotations Data");

    const timestamp = new Date().toISOString().split("T")[0];
    XLSX.writeFile(wb, `projects_data_${timestamp}.xlsx`);

    setLoading(false);
  };

  const flattenDumpData = async () => {
    setDumpLoad(true);
    const getToken = () => localStorage.getItem("u_token");
    const token = getToken();

    try {
      const response = await axios.get(`${Apiurl}admin/project/view`, {
        params: {
          search: searchTerm,
          from: selectedFromDate,
          to: selectedToDate,
          state: selectedState?.map((u) => u.value).join(","),
          user: selectedUsers?.map((u) => u.value).join(","),
          client: selectedClients?.map((u) => u.value).join(","),
          role: roleId?.map((u) => u.value).join(","),
          month: selectedMonth?.join(","),
          year: selectedYear?.map((y) => y.value).join(","),
          region: selectedRegion?.map((u) => u.value).join(",")
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.data || response.data.length === 0) {
        alert("No data found");
        setDumpLoad(false);
        return;
      }

      let processedData = [];
      let serialNumber = 1;
      const dumpData = response.data.data;

      dumpData?.forEach((item) => {
        if (item.sku_code) {
          processedData.push({
            "Sl No": serialNumber++,
            Username: item.username,
            "User's Region": item.user_region || "",
            "User's State": item.user_state || "",
            Role:
              item.role == 2
                ? "IC"
                : item.role == 3
                  ? "BSP"
                  : item.role == 4
                    ? "DSP"
                    : item.role == 5
                      ? "BD"
                      : item.role == 6
                        ? "Sales Enabler"
                        : item.role == 7
                          ? "Dealer"
                          : item.role == 8
                            ? "Studio"
                            : item.role,
            "Quotation ID": item.project_id,
            "Offer Price": item.offer_price && Number(item.offer_price) > 0
              ? new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(Number(item.offer_price))
              : item.list_price !== null && item.list_price !== undefined
                ? new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(Number(item.list_price))
                : "-",
            "List Price": item.list_price !== null && item.list_price !== undefined ? new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(Number(item.list_price)) : "-",
            "Client Name": item.client_name,
            "Client's Region": item.client_region || "",
            "Client's State": item.client_state || "",
            "HSN Code": item.hsnCode,
            "SKU Code": item.sku_code,
            Brand: item.brand,
            Finish: item.finish || "Not Found",
            Description: item.product_desc,
            Collection: item.collection || "Not Found",
            "GST (%)": item.gst,
            Quantity: item.qty,
            "MRP (₹)": item.mrp,
            Category: item.category,
            "Price Segment": item.priceSegment || "N/A",
            // "Spare FG": item.spare_fg || "N/A",
            "Product Type Group": item.product_typ_group || "Not Found",
            "Valid Upto": new Date(item.valid_date).toLocaleDateString(
              "en-GB"
            ),
            "Created At": new Date(item.created_at).toLocaleDateString(
              "en-GB"
            ),
            "Modified At": new Date(item.updated_at).toLocaleDateString(
              "en-GB"
            ),
          });
        } else {
          console.warn(`Product not found for Quoatation ID: ${item.project_id}`);
        }
      });

      if (processedData.length > 0) {
        handleDumpExcelDownload(processedData);
      }
    } catch (error) {
      console.error("Error fetching dump data:", error);
      alert("Failed to fetch data. Please try again.");
    } finally {
      setDumpLoad(false);
    }
  };

  const handleDumpExcelDownload = (flattenedData) => {
    const headers = flattenedData.length > 0 ? [Object.keys(flattenedData[0])] : [[]];

    const ws = XLSX.utils.aoa_to_sheet(headers);
    XLSX.utils.sheet_add_json(ws, flattenedData, {
      origin: "A2",
      skipHeader: true,
    });

    // We can remove the exact !cols array or just leave it empty if we want auto-width or we can keep it as is, but since we added new columns it will be misaligned anyway. It's safer to just set basic widths.
    const colWidths = headers[0].map(() => ({ wch: 20 }));
    ws["!cols"] = colWidths;


    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Dump Data");

    XLSX.writeFile(wb, "DumpData.xlsx");
    setLoading(false);
  };

  const viewProject = (id) => {
    try {
      navigate(`/admin/viewProjects?project_id=${id}`);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (showComponent) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [showComponent]);

  const downloadexcel = async (id) => {
    try {
      setprojectId(id);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (coverImages.length === 0) {
      dispatch(fetchCoverImages());
    }
    if (summaryImages.length === 0) {
      dispatch(fetchSummaryImages());
    }
    if (themeImages.length === 0) {
      dispatch(fetchThemeImages());
    }
    if (lastImages.length === 0) {
      dispatch(fetchLastImages());
    }
    if (techImages.length === 0) {
      dispatch(fetchTechImages());
    }
    if (communicationImages.length === 0) {
      dispatch(fetchCommunicationImages());
    }
  }, []);

  const handleClearFilters = () => {
    setSelectedUsers([]);
    setSelectedClients([]);
    setFromDate(null);
    setToDate(null);
    setSelectedFromDate(null);
    setSelectedRegion([]);
    setSelectedState([]);
    setSelectedToDate(null);
    setSearchTerm("");
    setRoleId([]);
    const fullFYMonths = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
    const currentCalendarMonth = new Date().getMonth() + 1;
    const currentMonthIndex = fullFYMonths.indexOf(currentCalendarMonth);

    setSelectedMonth(fullFYMonths.slice(0, currentMonthIndex + 1));
    const currentYrStr = String(new Date().getFullYear());
    setSelectedYear(FY_YEAR_OPTIONS.filter((y) => y.value === currentYrStr));
  };

  const currentYear = new Date().getFullYear();
  const startYear = 2023;
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  );

  const monthOption = [
    { label: "All Month", value: "" },
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
  ];

  const handleSort = (column) => {
    setSortBy((prev) => {
      if (prev.sort_by === column) {
        return {
          sort_by: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      }
      return { sort_by: column, order: "asc" };
    });
  };

  const [selectedRows, setSelectedRows] = useState([]);
  const [isShareOpen, setIsShareOpen] = useState(false);

  const handleSelectRow = (row) => {
    setSelectedRows((prev) => {
      const isSelected = prev.find((item) => item.id === row.id);
      if (isSelected) {
        return prev.filter((item) => item.id !== row.id);
      } else {
        return [
          ...prev,
          {
            id: row.id,
            project_id: row.project_id,
            shared: row.shared,
          },
        ];
      }
    });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allSelected = projectData.map((row) => ({
        id: row.id,
        project_id: row.project_id,
        shared: row.shared,
      }));
      setSelectedRows(allSelected);
    } else {
      setSelectedRows([]);
    }
  };

  const handleShareSubmit = async (payload) => {
    setLoading(true);
    try {
      const requests = payload.map((data) =>
        axios.post(
          `${Apiurl}admin/share-quotations`,
          {
            project_ids: data.project_ids,
            user_ids: data.user_ids,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("u_token")}`,
            },
          }
        )
      );

      await Promise.all(requests);

      dispatch(
        fetchProject({
          search: searchTerm,
          from: selectedFromDate,
          to: selectedToDate,
          state: selectedState?.map((u) => u.value),
          region: selectedRegion?.map((u) => u.value),
          month: selectedMonth,
          year: selectedYear,
          user: selectedUsers?.map((u) => u.value),
          client: selectedClients?.map((u) => u.value),
          page: page,
          rowsPerPage: rowsPerPage,
          sort_by: sortBy.sort_by,
          sort_order: sortBy.order,
          role: roleId?.map((u) => u.value),
        })
      );

      Swal.fire("Success", "All quotation share settings updated!", "success");
      setSelectedRows([]);
      setIsShareOpen(false);
    } catch (error) {
      Swal.fire("Error", "Failed to process", error);
    } finally {
      setLoading(false);
    }
  };

  const currentFilters = {
    search: searchTerm || "",
    from: fromDate || "",
    to: toDate || "",
    month: selectedMonth?.join(",") || "",
    year: selectedYear?.map((y) => y.value)?.join(",") || "",
    user: selectedUsers?.map((u) => u.value)?.join(",") || "",
    client: selectedClients?.map((u) => u.value)?.join(",") || "",
    state: selectedState?.map((u) => u.value)?.join(",") || "",
    region: selectedRegion?.map((u) => u.value)?.join(",") || "",
    role: roleId?.map((u) => u.value)?.join(",") || "",
  };

  return (
    <>
      <ShareQuoteDialog
        open={isShareOpen}
        onClose={() => setIsShareOpen(false)}
        users={userOpt}
        selectedQuotes={selectedRows}
        onShare={handleShareSubmit}
      />
      <MainLayout title={'Quotations'} disableScroll={true}>
        <Box sx={{ position: 'sticky', top: 0, zIndex: 10, pt: 1, flexShrink: 0 }}>
          <AllQuotationsAnalysis
            totalQuotation={hasValidFilters ? (stats?.quotationIds || 0) : 0}
            totalUser={hasValidFilters ? (stats?.usernames || 0) : 0}
            totalClient={hasValidFilters ? (stats?.clients || 0) : 0}
            loading={hasValidFilters && (status === 'pending' || status === 'idle')}
          />
        </Box>
        <Box sx={{ flexShrink: 0 }}>
          <FilterBar2
            filters={filterConfigs}
            onFilterChange={handleFilterChange}
            selectedMonth={selectedMonth}
            setSelectedMonth={handleMonthChange}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            selectedFromDate={selectedFromDate}
            setSelectedFromDate={setSelectedFromDate}
            selectedToDate={selectedToDate}
            setSelectedToDate={setSelectedToDate}
            onClearFilters={handleClearFilters}
            actions={
              <div className="flex items-center gap-2">
                <ExtractAllButtonThree
                  filters={currentFilters}
                  totalCount={hasValidFilters ? counts : 0}
                  userOpt={userOpt}
                  disabled={!hasValidFilters}
                />

                <Button
                  variant="contained"
                  startIcon={<TableChartIcon />}
                  onClick={handleDownloadExcel}
                  sx={{
                    textTransform: "none",
                    bgcolor: "#2e7d32",
                    py: '2px',
                    px: '14px',
                    borderRadius: 12,
                    fontSize: "12px",
                    "&:hover": { bgcolor: "#1b5e20" },
                  }}
                >
                  Excel
                </Button>

                <Button
                  variant="contained"
                  startIcon={<PeopleAltIcon />}
                  onClick={() => setIsShareOpen(true)}
                  disabled={selectedRows.length === 0}
                  sx={{
                    textTransform: "none",
                    bgcolor: "#673ab7",
                    whiteSpace: "nowrap",
                    py: '2px',
                    px: '14px',
                    borderRadius: 12, fontSize: "12px",
                    "&:hover": { bgcolor: "#512da8" },
                  }}
                >
                  Share {selectedRows.length > 0 ? `(${selectedRows.length})` : ""}
                </Button>
              </div>
            }
          />
        </Box>

        <Paper sx={{ margin: "", padding: "", flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
          <TableContainer component={Paper} sx={{ flex: 1, overflow: "auto" }}>
            <Table stickyHeader id="excedata" sx={{
              "& .MuiTableHead-root .MuiTableCell-root": {
                backgroundColor: "#04121f !important",
                color: "white !important",
              }
            }}>
              <TableHead sx={{ background: "#04121f", color: "white" }}>
                <TableRow>
                  <TableCell sx={{ bgcolor: "#04121f" }}>
                    <Checkbox
                      indeterminate={
                        selectedRows.length > 0 &&
                        selectedRows.length < projectData?.length
                      }
                      checked={
                        projectData?.length > 0 &&
                        selectedRows.length === projectData?.length
                      }
                      onChange={handleSelectAll}
                      sx={{ color: "white !important" }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    SL No.
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Excel/PDF
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Preview
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Quotation ID
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Offer Price
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    List Price
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <TableSortLabel
                      active={sortBy.sort_by === "client"}
                      direction={
                        sortBy.sort_by === "client" ? sortBy.order : "desc"
                      }
                      onClick={() => handleSort("client")}
                      hideSortIcon={false} // <-- keep icon visible even when inactive
                      sx={{
                        color: "white !important",
                        cursor: "pointer",
                        "& .MuiTableSortLabel-icon": {
                          opacity: 1, // <-- don't fade when inactive
                          color: "white !important",
                        },
                      }}
                    >
                      Client
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >

                    Client's Region
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >

                    Client's State
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <TableSortLabel
                      active={sortBy.sort_by === "username"}
                      direction={
                        sortBy.sort_by === "username" ? sortBy.order : "desc"
                      }
                      onClick={() => handleSort("username")}
                      hideSortIcon={false}
                      sx={{
                        color: "white !important",
                        cursor: "pointer",
                        "& .MuiTableSortLabel-icon": {
                          opacity: 1,
                          color: "white !important",
                        },
                      }}
                    >
                      Username
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >

                    User's Region
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >

                    User's State
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <TableSortLabel
                      active={sortBy.sort_by === "role_id"}
                      direction={
                        sortBy.sort_by === "role_id" ? sortBy.order : "desc"
                      }
                      onClick={() => handleSort("role_id")}
                      hideSortIcon={false}
                      sx={{
                        color: "white !important",
                        cursor: "pointer",
                        "& .MuiTableSortLabel-icon": {
                          opacity: 1,
                          color: "white !important",
                        },
                      }}
                    >
                      Role
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Shared With
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Transferred From
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    PDF | Excel | Whatsapp
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <TableSortLabel
                      active={sortBy.sort_by === "valid_upto"}
                      direction={
                        sortBy.sort_by === "valid_upto" ? sortBy.order : "desc"
                      }
                      onClick={() => handleSort("valid_upto")}
                      hideSortIcon={false} // <-- keep icon visible even when inactive
                      sx={{
                        color: "white !important",
                        cursor: "pointer",
                        "& .MuiTableSortLabel-icon": {
                          opacity: 1, // <-- don't fade when inactive
                          color: "white !important",
                        },
                      }}
                    >
                      Valid Upto
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Stage
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <TableSortLabel
                      active={sortBy.sort_by === "created_at"}
                      direction={
                        sortBy.sort_by === "created_at" ? sortBy.order : "desc"
                      }
                      onClick={() => handleSort("created_at")}
                      hideSortIcon={false} // <-- keep icon visible even when inactive
                      sx={{
                        color: "white !important",
                        cursor: "pointer",
                        "& .MuiTableSortLabel-icon": {
                          opacity: 1, // <-- don't fade when inactive
                          color: "white !important",
                        },
                      }}
                    >
                      Created At
                    </TableSortLabel>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Month
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Year
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Time
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Updated At
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Update Time
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(() => {
                  if (!hasValidFilters) {
                    return (
                      <TableRow>
                        <TableCell colSpan={25} align="center">
                          No data
                        </TableCell>
                      </TableRow>
                    );
                  }
                  return (status === "pending" || loading) ? (
                    <TableBodySkeleton cols={23} rows={10} hasActions />
                  ) : projectData?.length > 0 ? (
                    projectData.map(
                      (
                        {
                          id,
                          client_name,
                          client_region,
                          client_state,
                          username,
                          user_region,
                          user_state,
                          role,
                          project_id,
                          valid_date,
                          created_at,
                          sku_codes,
                          updated_at,
                          products,
                          status,
                          shared,
                          transferred_user_name,
                          whatsCount,
                          pdfCount,
                          excelCount,
                          offer_price,
                          list_price
                        },
                        index
                      ) => (
                        <TableRow key={id}>
                          <TableCell>
                            <Checkbox
                              checked={selectedRows.some(
                                (item) => item.id === id
                              )}
                              onChange={() =>
                                handleSelectRow({
                                  id,
                                  project_id,
                                  shared,
                                })
                              }
                            />
                          </TableCell>
                          <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                          <TableCell>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <IconButton
                                color="primary"
                                onClick={() => {
                                  downloadexcel(project_id);
                                  setExcelLoading(true);
                                }}
                              >
                                <DownloadIcon className="cursor-pointer hover:scale-125" />
                              </IconButton>
                              <IconButton
                                color="primary"
                                onClick={() => downloadPdf(project_id, `${Apiurl}user/downloadPdf`)}
                              >
                                <PictureAsPdfIcon className="cursor-pointer text-red-600 scale-125 hover:scale-150" />
                              </IconButton>
                              <IconButton
                                color="primary"
                                onClick={() => downloadPdf(project_id, `${Apiurl}user/product-log`)}
                              >
                                <AutoAwesomeMotionIcon className="cursor-pointer text-red-600 scale-125 hover:scale-150" />
                              </IconButton>
                            </div>
                          </TableCell>
                          <TableCell>
                            <IconButton
                              color="error"
                              onClick={() => {
                                viewProject(project_id);
                                localStorage.setItem("projectId", project_id);
                              }}
                            >
                              <PreviewIcon className="cursor-pointer hover:scale-125" />
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            <div className="flex items-center gap-2">
                              <span>{project_id}</span>
                              {transferred_user_name && (
                                <span className="relative flex h-5 w-5">
                                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 "></span>
                                  <span className="relative inline-flex items-center justify-center rounded-full h-5 w-5 bg-orange-600 text-white text-[10px] font-bold">
                                    T
                                  </span>
                                </span>
                              )}
                            </div>
                          </TableCell>
                          <TableCell>
                            {offer_price && Number(offer_price) > 0
                              ? new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(Number(offer_price))
                              : list_price !== null && list_price !== undefined
                                ? new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(Number(list_price))
                                : '-'}
                          </TableCell>
                          <TableCell>{list_price !== null && list_price !== undefined ? new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(Number(list_price)) : '-'}</TableCell>
                          <TableCell><ClickableTableLink path="/admin/clientlist" displayValue={client_name} searchValue={client_name} /></TableCell>
                          <TableCell>{client_region}</TableCell>
                          <TableCell>{client_state}</TableCell>

                          <TableCell><ClickableTableLink path="/admin/userlist" displayValue={username} searchValue={username} /></TableCell>
                          <TableCell>{user_region}</TableCell>
                          <TableCell>{user_state}</TableCell>
                          <TableCell>
                            <ClickableTableLink path="/admin/userlist" displayValue={role == 2
                              ? "IC"
                              : role == 3
                                ? "BSP"
                                : role == 4
                                  ? "DSP"
                                  : role == 5
                                    ? "BD"
                                    : role == 6
                                      ? "Sales Enabler"
                                      : role == 7
                                        ? "Dealer"
                                        : role == 8
                                          ? "Studio"
                                          : role} searchValue="" role={role} />

                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              {shared ? (
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  {shared
                                    .split(",")
                                    .slice(0, 3)
                                    .map((userId, i) => {
                                      const sharedUser = userOpt?.find(
                                        (u) => String(u.value) === userId.trim()
                                      );
                                      const label = sharedUser
                                        ? sharedUser.label
                                        : "Unknown User";

                                      return (
                                        <Tooltip
                                          key={userId}
                                          title={label}
                                          arrow
                                          placement="top"
                                        >
                                          <Avatar
                                            sx={{
                                              width: 28,
                                              height: 28,
                                              fontSize: "0.75rem",
                                              fontWeight: 600,
                                              bgcolor: "#04121f",
                                              color: "white",
                                              border: "2px solid white",
                                              marginLeft: i === 0 ? 0 : "-10px",
                                              boxShadow:
                                                "0 2px 4px rgba(0,0,0,0.1)",
                                              cursor: "default",
                                            }}
                                          >
                                            {label.charAt(0).toUpperCase()}
                                          </Avatar>
                                        </Tooltip>
                                      );
                                    })}

                                  {shared.split(",").length > 3 && (
                                    <Tooltip
                                      title={shared
                                        .split(",")
                                        .slice(3)
                                        .map((id) => {
                                          const u = userOpt?.find(
                                            (opt) =>
                                              String(opt.value) === id.trim()
                                          );
                                          return u ? u.label : "Unknown";
                                        })
                                        .join(", ")}
                                      arrow
                                      placement="top"
                                    >
                                      <Avatar
                                        sx={{
                                          width: 28,
                                          height: 28,
                                          fontSize: "0.7rem",
                                          bgcolor: "#e2e8f0",
                                          color: "#475569",
                                          border: "2px solid white",
                                          marginLeft: "-10px",
                                          fontWeight: 700,
                                          cursor: "default",
                                        }}
                                      >
                                        +{shared.split(",").length - 3}
                                      </Avatar>
                                    </Tooltip>
                                  )}
                                </Box>
                              ) : (
                                <Typography
                                  variant="caption"
                                  sx={{ color: "#94a3b8" }}
                                >
                                  Not Shared
                                </Typography>
                              )}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="caption"
                              sx={{ color: "#757574" }}
                            >
                              {transferred_user_name
                                ? transferred_user_name
                                : "Not Transferred"}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography
                              variant="caption"
                              sx={{ color: "#757574" }}
                            >
                              {`${pdfCount || 0} | ${excelCount || 0} | ${whatsCount || 0}`}
                            </Typography>
                          </TableCell>
                          <TableCell
                            style={{
                              color: (() => {
                                const validDate = new Date(valid_date);
                                const currentDate = new Date();
                                currentDate.setHours(0, 0, 0, 0);
                                validDate.setHours(0, 0, 0, 0);
                                if (
                                  validDate.toDateString() ===
                                  currentDate.toDateString()
                                ) {
                                  return "green";
                                } else if (validDate < currentDate) {
                                  return "red";
                                } else if (
                                  validDate.toDateString() ===
                                  new Date(
                                    currentDate.setDate(currentDate.getDate() + 1)
                                  ).toDateString()
                                ) {
                                  return "black";
                                }
                                return "black";
                              })(),
                            }}
                          >
                            {new Date(valid_date).toLocaleDateString("en-GB")}
                          </TableCell>

                          <TableCell>{status}</TableCell>
                          <TableCell>
                            {" "}
                            {new Date(created_at).toLocaleDateString(
                              "en-GB"
                            )}{" "}
                          </TableCell>
                          <TableCell>
                            {new Date(created_at).toLocaleString("default", { month: "short" })}
                          </TableCell>
                          <TableCell>
                            {new Date(created_at).getFullYear()}
                          </TableCell>
                          <TableCell>
                            {" "}
                            {new Date(created_at).toLocaleTimeString()}{" "}
                          </TableCell>
                          <TableCell>
                            {" "}
                            {new Date(updated_at).toLocaleDateString(
                              "en-GB"
                            )}{" "}
                          </TableCell>
                          <TableCell>
                            {" "}
                            {new Date(updated_at).toLocaleTimeString()}{" "}
                          </TableCell>
                        </TableRow>
                      )
                    )
                  ) : (
                    <TableRow>
                      <TableCell colSpan={25} align="center">
                        No quotations found
                      </TableCell>
                    </TableRow>
                  );
                })()}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={hasValidFilters ? [10, 25, 100, 500, counts] : [10, 25, 100, 500]}
            component="div"
            count={hasValidFilters ? (counts || 0) : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              paddingTop: 2,
              paddingBottom: 2,
            }}
          />
        </Paper>
      </MainLayout>
      <div style={{ display: showComponent ? "block" : "none" }}>
        <DownloadSummary
          project={projectId}
          sendData={handleDataFromDownloadSummary}
        />
      </div>
    </>
  );
};

export default Projects;
